export const UPDATE_PASSWORD_INITIATED = "UPDATE_PASSWORD_INITIATED";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_FAILED = "UPDATE_PASSWORD_FAILED";
export const RESET_STATE = "RESET_STATE";
